import {PrescoreCheck} from "./Prescore";

export enum OnboardingStep {
    PRESCORING = "PRESCORING",
    IDENTIFICATION = "IDENTIFICATION",
    SCORING = "SCORING",
    LEGAL = "LEGAL",
    PROJECT_CREATION = "PROJECT_CREATION",
}

export enum StepStatus {
    IN_PROGRESS = "IN_PROGRESS",
    WAITING_APPROVAL = "WAITING_APPROVAL",
    REJECTED = "REJECTED",
}

export interface BorrowerOnboarding {
    currentStep: OnboardingStep;
    stepStatus: StepStatus;
    stepNote?: string;
    lastPrescoreChecks?: PrescoreCheck[]
}